import api from './index';

export default {
	getPosts(locale) {
		return api().get(`/blogPost/${locale}`)
	}
}